"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Annotation = void 0;
const AnnotationHotspot_1 = require("./AnnotationHotspot");
const AnnotationPopover_1 = require("./AnnotationPopover");
const three_1 = require("three");
class Annotation {
    constructor(annotation, includeControls = true) {
        var _a;
        this._imageBlobUrl = null;
        this._imageId = null;
        this._imageFile = null;
        this._group = new three_1.Group();
        this.loadingImage = false;
        this._manualId = annotation.manualId;
        this._id = annotation.id;
        this._name = annotation.name || "";
        this._content = annotation.content || "";
        this._url = annotation.url;
        this._annotationPoint = annotation.annotationPoint;
        this._cameraPoint = annotation.cameraPoint;
        this._orderNumber = annotation.orderNumber || 0;
        this._annotationHotspot = new AnnotationHotspot_1.AnnotationHotspot(annotation);
        this._annotationPopover = new AnnotationPopover_1.AnnotationPopover(annotation);
        // Check if it includes "![<imageId>]" (image)
        // Extract that image id into this.annotationImages and replace that part with empty string
        // so that it is not shown in textarea
        const reg = new RegExp(/!\[([a-f0-9-]+)\]/);
        if (annotation.content && reg.test(annotation.content)) {
            const imageId = (_a = reg.exec(annotation.content)) === null || _a === void 0 ? void 0 : _a[1];
            if (imageId) {
                this._imageId = imageId;
                // Replace image info with empty string
                this.content = annotation.content.replace(/!\[[a-f0-9-]+\]/, '');
            }
        }
        if (includeControls) {
            PubSub.publish("update-annotation-controler" /* UPDATE_ANNOTATION_CONTROL */, this);
        }
        this._group.add(this._annotationHotspot.element, this._annotationPopover.element);
    }
    get manualId() { return this._manualId; }
    set manualId(manualId) { this._manualId = manualId; }
    get id() { return this._id; }
    set id(id) { this._id = id; }
    get orderNumber() { return this._orderNumber; }
    set orderNumber(orderNumber) {
        this._orderNumber = orderNumber;
        this._annotationHotspot.orderNumber = orderNumber;
        PubSub.publish("update-annotation-controler" /* UPDATE_ANNOTATION_CONTROL */, this);
    }
    get name() { return this._name; }
    set name(name) {
        this._name = name;
        this._annotationPopover.name = name;
        PubSub.publish("update-annotation-controler" /* UPDATE_ANNOTATION_CONTROL */, this);
    }
    get content() { return this._content; }
    set content(content) {
        this._content = content;
        this._annotationPopover.content = content;
    }
    get url() { return this._url; }
    set url(url) { this._url = url; }
    get annotationPoint() { return this._annotationPoint; }
    set annotationPoint(annotationPoint) { this._annotationPoint = annotationPoint; }
    get cameraPoint() { return this._cameraPoint; }
    set cameraPoint(cameraPoint) { this._cameraPoint = cameraPoint; }
    get annotationHotspot() { return this._annotationHotspot; }
    set annotationHotspot(annotationHotspot) { this._annotationHotspot = annotationHotspot; }
    get annotationPopover() { return this._annotationPopover; }
    set annotationPopover(annotationPopover) { this._annotationPopover = annotationPopover; }
    get imageId() { return this._imageId || ''; }
    set imageId(id) {
        this._imageId = id;
    }
    get imagePlaceholder() {
        return this._imageId ? `![${this.imageId}]` : '';
    }
    get imageBlobUrl() {
        return this._imageBlobUrl;
    }
    get imageFile() {
        return this._imageFile;
    }
    get hasImage() {
        return !!(this.imageId && this.imageBlobUrl);
    }
    get group() { return this._group; }
    set group(group) { this._group = group; }
    dispose() {
        var _a, _b;
        (_a = this._annotationHotspot) === null || _a === void 0 ? void 0 : _a.dispose();
        (_b = this._annotationPopover) === null || _b === void 0 ? void 0 : _b.dispose();
    }
    addImage(imageId, blobUrl) {
        this._imageId = imageId;
        this._imageBlobUrl = blobUrl;
        this._annotationPopover.showImage(blobUrl);
    }
    removeImage() {
        URL.revokeObjectURL(this._imageBlobUrl || '');
        this._imageId = null;
        this._imageBlobUrl = null;
        this._annotationPopover.hideImage();
    }
    // Image is converted to blob url and used to display image
    // images are uploaded before annotations are saved
    addImageAsFile(file) {
        this._imageId = null;
        this._imageFile = file;
        this._imageBlobUrl = URL.createObjectURL(file);
        this._annotationPopover.showImage(this._imageBlobUrl);
    }
}
exports.Annotation = Annotation;
